/** Hono RPC client for @takelead/api. Use with token from AuthContext. */
import { hc } from "hono/client";
import type { AppType } from "@takelead/api";
import { getApiUrl } from "@/config";

/** Pro Aufruf auflösen — nicht beim Modul-Load (Origin/Preview vs. Prod). */
export function createApiClient(accessToken: string) {
  const baseUrl = getApiUrl().replace(/\/$/, "");
  return hc<AppType>(baseUrl, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    },
  });
}

export type ApiClient = ReturnType<typeof createApiClient>;
